import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, CardItem, inject, ModalHandle, StatusCard } from 'Mri.Web.Common';
import * as React from 'react';
import { Collapse } from 'reactstrap';
import { ActiveDisplay } from '../../ActiveDisplay';
import { DisplaysStore } from '../../DisplaysStore';

export interface IDisplayPowerInletCardProps {
    readonly telemetryPoll?: Mri.TelemetryPolls.TelemetryPoll;
    readonly loading: boolean;
}

@autoinject
@observer
export class DisplayPowerInletCard extends React.Component<IDisplayPowerInletCardProps> {
    public render() {
        const measurements = this.props.telemetryPoll?.measurements;
        const collapsible = true;
        return (
            <StatusCard title="Inlet Power">
                {measurements && (
                    <>
                        <CardItem
                            label="Avg Inlet Volts"
                            value={this.measurementValue(this.measurement(Mri.WebApi.MeasurementId.AvgInletVolts))}
                        />
                        <CardItem
                            label="Total Inlet Amps"
                            value={this.measurementValue(this.measurement(Mri.WebApi.MeasurementId.TotalInletAmps))}
                        />
                        <CardItem
                            label="Total Inlet Watts"
                            value={this.measurementValue(this.measurement(Mri.WebApi.MeasurementId.TotalInletWatts))}
                        />
                        <CardItem
                            label="Filtered Inlet Volts"
                            value={this.measurementValue(this.measurement(Mri.WebApi.MeasurementId.FilteredInletVolts))}
                        />
                        <CardItem
                            label="Power Consumption"
                            value={this.measurementValue(this.measurement(Mri.WebApi.MeasurementId.KilowattHour))}
                        />
                        <CardItem
                            label="Total Unit Power Consumption"
                            value={this.measurementValue(this.measurement(Mri.WebApi.MeasurementId.UnitKilowattHour))}
                        />
                    </>
                )}

                {collapsible && (
                    <a className="btn btn-link p-0 p-md-2" onClick={this.onToggle}>
                        {this.collapsed ? 'Expand' : 'Hide'} Inlet Power
                    </a>
                )}
                <Collapse isOpen={!this.collapsed}>
                    <CardItem label="Inlet 1" value="" header />
                    <CardItem
                        label="Voltage"
                        value={this.measurementValue(this.measurement(Mri.WebApi.MeasurementId.Inlet1Volts))}
                    />

                    <CardItem
                        label="Current"
                        value={this.measurementValue(this.measurement(Mri.WebApi.MeasurementId.Inlet1Amps))}
                    />
                    <CardItem
                        label="Wattage"
                        value={this.measurementValue(this.measurement(Mri.WebApi.MeasurementId.Inlet1Watts))}
                    />

                    <CardItem label="Inlet 2" value="" header />
                    <CardItem
                        label="Voltage"
                        value={this.measurementValue(this.measurement(Mri.WebApi.MeasurementId.Inlet2Volts))}
                    />

                    <CardItem
                        label="Current"
                        value={this.measurementValue(this.measurement(Mri.WebApi.MeasurementId.Inlet2Amps))}
                    />
                    <CardItem
                        label="Wattage"
                        value={this.measurementValue(this.measurement(Mri.WebApi.MeasurementId.Inlet2Watts))}
                    />

                    <CardItem label="Inlet 3" value="" header />
                    <CardItem
                        label="Voltage"
                        value={this.measurementValue(this.measurement(Mri.WebApi.MeasurementId.Inlet3Volts))}
                    />

                    <CardItem
                        label="Current"
                        value={this.measurementValue(this.measurement(Mri.WebApi.MeasurementId.Inlet3Amps))}
                    />
                    <CardItem
                        label="Wattage"
                        value={this.measurementValue(this.measurement(Mri.WebApi.MeasurementId.Inlet3Watts))}
                    />

                    <CardItem label="Inlet 4" value="" header />
                    <CardItem
                        label="Voltage"
                        value={this.measurementValue(this.measurement(Mri.WebApi.MeasurementId.Inlet4Volts))}
                    />

                    <CardItem
                        label="Current"
                        value={this.measurementValue(this.measurement(Mri.WebApi.MeasurementId.Inlet4Amps))}
                    />
                    <CardItem
                        label="Wattage"
                        value={this.measurementValue(this.measurement(Mri.WebApi.MeasurementId.Inlet4Watts))}
                    />
                </Collapse>
            </StatusCard>
        );
    }

    @bind
    private measurement(measurementId: Mri.WebApi.MeasurementId) {
        if (this.props.telemetryPoll?.measurements) {
            return this.props.telemetryPoll.measurements.find(s => s.id == measurementId);
        }
    }

    @bind
    private measurementValue(measurement?: Mri.WebApi.Measurement) {
        if (measurement) {
            const units = measurement.units || '';

            if (measurement.boolValue) return measurement.boolValue + units;
            if (measurement.doubleValue) return measurement.doubleValue.toFixed(2) + units;
            if (measurement.floatValue) return measurement.floatValue.toFixed(2) + units;
            if (measurement.intValue) return measurement.intValue.toFixed(2) + units;
            if (measurement.stringValue) return measurement.stringValue + units;
            if (measurement.durationValue) return measurement.durationValue.toString() + units;
        } else return '-';
    }

    @bind
    @action
    private onToggle() {
        this.collapsed = !this.collapsed;
    }

    @observable
    private collapsed = true;
}
